import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getListFeedbackManagerStart,
  getListFeedbackManagerSuccess,
  getListFeedbackManagerFailed,
} from "../redux/getListFeedbackManager";
import { getListFeedbackManagerAPI } from "core/http/service/decleareLeave";
import moment from "moment";

function* getListFeedbackManagerWork(action) {
  const { screenCode, ...payload } = action.payload;
  try {
    const res = yield call(getListFeedbackManagerAPI, {
      screenCode,
      ...payload,
    });
    const formattedData = res.data.map((item, index) => ({
      ...item,
      index: index + 1,
      fromDate: moment(item?.fromDate),
      toDate: moment(item?.toDate),
    }));
    yield put({
      type: getListFeedbackManagerSuccess.type,
      payload: formattedData,
    });
  } catch (error: any) {
    yield put({
      type: getListFeedbackManagerFailed.type,
    });
  }
}

function* watchGetListFeedbackManager() {
  yield takeLatest(
    getListFeedbackManagerStart.type,
    getListFeedbackManagerWork
  );
}

export default function* getListFeedbackManagerSaga() {
  yield all([watchGetListFeedbackManager()]);
}
